import React, { useState, useEffect } from 'react';

import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import SmartSearchTermsAutocomplete from './SmartSearchTermsAutocomplete';

import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import moment from 'moment';
moment.locale(freedomeConfig.locale);
/**/
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { useBlockScroll } from '../../hooks/useBlockScroll';
import {
  DATE_FORMATS,
  DROPDOWN_MBL_BEHAVIOUR,
  QUERY_PARAMS,
} from '../../../constants';
import { useDaySize } from '../../hooks/useDaySize';

import { Icon, InlineIcon } from '@iconify/react';
import iconCalendar from '@iconify-icons/mdi/calendar-today';

const _DEFAULT_PLACEHOLDER_TEXT = app_main_wpml.search_when_placeholder;
const _ALWAYS_PLACEHOLDER = app_main_wpml.always;
const _NEXT_MONTH_PLACEHOLDER = app_main_wpml.next_month_full;
const _NEXT_TO_ME = app_main_wpml.close_to_me;

const SmartSearchForm = (props) => {

  const [userLocation, setUserLocation] = useState(JSON.parse(localStorage.getItem('userLocation')));

  const [isAlways, setIsAlways] = useState(props.isAlways);
  const [isNextMonth, setIsNextMonth] = useState(props.isNextMonth);

  const [placeholderText, setPlaceholderText] = React.useState(() => {
    if (isAlways) return _ALWAYS_PLACEHOLDER;
    if (isNextMonth && !(startDate || endDate)) return _NEXT_MONTH_PLACEHOLDER;
    return _DEFAULT_PLACEHOLDER_TEXT;
  });

  const isDeviceSmallerThanTablet = !useMatchesMinWidth(768);
  const [startDate, setStartDate] = React.useState(props.initialStartDate);
  const [endDate, setEndDate] = React.useState(props.initialEndDate);
  const [focusedInput, setFocusedInput] = React.useState(null);
  const [isDatepickerVisible, setIsDatepickerVisible] = React.useState(props.isDatepickerVisible);
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);
  useBlockScroll(isDeviceSmallerThanTablet && isDatePickerOpen);

  React.useEffect(() => {
    if (startDate || endDate) {
      setPlaceholderText(_DEFAULT_PLACEHOLDER_TEXT);
    }
  }, [startDate, endDate]);

  const daySize = useDaySize();

  const [selectedSearchable, setSelectedSearchable] = useState({
    title: props.initialSearchTerm,
    type: 'location',
    id: 0
  });

  //useEffect(() => { setSelectedSearchTerm(props.initialSearchTerm) }, [props.initialSearchTerm]);

  const handleSearchableChange = (searchable) => {
    setIsDatepickerVisible(!!searchable);
    setSelectedSearchable(searchable);
  };

  return (
    <div className={classNames('search-section', props.className)}>
      <form
        className={'search-section__form'}
        method={'GET'}
        action={props.catalogueUrl}
      >
        <div
          className={classNames('search-section__location-input', {
            'search-section__location-input--icon-primary': !!selectedSearchable.title,
          })}
        >
          <SmartSearchTermsAutocomplete
            selectedSearchTerm={selectedSearchable.title ? selectedSearchable.title : ''}
            onSearchTermSelect={handleSearchableChange}
            setUserLocation={setUserLocation}
            scrollOnFocus={props.scrollOnFocus}
          />
        </div>
        
        {isDatepickerVisible === true && (
          <div className={classNames('date-range-container')}>
            <div
              className={classNames('date-range-container__placeholder', {
                'date-range-container__placeholder--visible':
                  !startDate && !endDate,
                'date-range-container__placeholder--always':
                  placeholderText === _ALWAYS_PLACEHOLDER ||
                  placeholderText === _NEXT_MONTH_PLACEHOLDER,
              })}
            >
              <Icon icon={iconCalendar} className="icon" />
              {placeholderText}
            </div>
            <DateRangePicker
              daySize={daySize}
              renderCalendarInfo={() => {
                return (
                  <div className={'datepicker-presets'}>
                    <button
                      className={classNames('btn', 'datepicker-presets__button')}
                      onClick={() => {
                        const nextWeekStart = moment().add(1, 'days');
                        const nextWeekEnd = moment().add(7, 'days');
                        setStartDate(nextWeekStart);
                        setEndDate(nextWeekEnd);
                        setFocusedInput(null);
                      }}
                    >
                      {app_main_wpml.next_week}
                    </button>
                    <button
                      className={classNames('btn', 'datepicker-presets__button')}
                      onClick={() => {
                        const nextMonthStart = moment().add(1, 'day');
                        const nextMonthEnd = moment().add(31, 'day');
                        setStartDate(nextMonthStart);
                        setEndDate(nextMonthEnd);
                        setFocusedInput(null);
                      }}
                    >
                      {app_main_wpml.next_month}
                    </button>
                    <button
                      className={classNames('btn', 'datepicker-presets__button')}
                      onClick={() => {
                        setPlaceholderText(_ALWAYS_PLACEHOLDER);
                        setStartDate(null);
                        setEndDate(null);
                        setFocusedInput(null);
                        setIsAlways(true);
                      }}
                    >
                      {app_main_wpml.always}
                    </button>
                    <div class="datepicker-title">{app_main_wpml.choose_period}</div>
                  </div>
                );
              }}
              weekDayFormat="ddd"
              startDate={startDate}
              endDate={endDate}
              startDateId=''
              endDateId=''
              onDatesChange={({ startDate, endDate }) => {
                setStartDate(startDate);
                setEndDate(endDate);
              }}
              minimumNights={0}
              enableOutsideDays={true}
              withPortal={isDeviceSmallerThanTablet}
              displayFormat={DATE_FORMATS.SEARCH_FORM_FE_VISUALIZATION}
              onFocusChange={(focusedInput) => {
                if (['startDate', 'endDate'].includes(focusedInput)) {
                  setIsDatePickerOpen(true);
                } else {
                  setIsDatePickerOpen(false);
                }
                setFocusedInput(focusedInput);
              }}
              focusedInput={focusedInput}
              numberOfMonths={1}
              readOnly
              startDatePlaceholderText={app_main_wpml.search_form}
              endDatePlaceholderText={app_main_wpml.search_to}
              hideKeyboardShortcutsPanel={true}
            />
          </div>
        )}
        {placeholderText === _ALWAYS_PLACEHOLDER && (
          <input name={QUERY_PARAMS.ALWAYS} value={true} hidden readOnly />
        )}
        {placeholderText !== _ALWAYS_PLACEHOLDER &&
          props.defaultDatesOnSubmit &&
          !startDate &&
          !endDate && (
            <input
              name={QUERY_PARAMS.NEXT_MONTH}
              value={true}
              hidden
              readOnly
            />
          )}
        <input
          hidden
          readOnly
          name={QUERY_PARAMS.START_DATE}
          value={
            startDate
              ? moment(startDate).format(
                DATE_FORMATS.SEARCH_FORM_BE_VISUALIZATION
              )
              : ''
          }
          data-gtm-item="search-form"
          data-gtm-detail="start_date"
        />
        <input
          hidden
          readOnly
          name={QUERY_PARAMS.END_DATE}
          value={
            endDate
              ? moment(endDate).format(
                DATE_FORMATS.SEARCH_FORM_BE_VISUALIZATION
              )
              : ''
          }
          data-gtm-item="search-form"
          data-gtm-detail="end_date"
        />
        <button
          className={classNames(
            'search-section__form__search-btn',
            'btn',
            'btn--primary',
            'btn--expanded',
            'btn--no-min-width'
          )}
          type={props.onSubmit ? 'button' : 'submit'}
          onClick={() => {
            if (props.onSubmit) {
              props.onSubmit(selectedSearchable, startDate, endDate, isAlways);
            }
          }}
        >
          {app_main_wpml.search_cta}
        </button>
      </form>
    </div>
  );
};

SmartSearchForm.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  catalogueUrl: PropTypes.string,
  initialStartDate: PropTypes.instanceOf(moment),
  initialEndDate: PropTypes.instanceOf(moment),
  initialSearchTerm: PropTypes.string,
  isAlways: PropTypes.bool.isRequired,
  isNextMonth: PropTypes.bool.isRequired,
  isDatepickerVisible: PropTypes.bool.isRequired,
  scrollOnFocus: PropTypes.bool,
  defaultDatesOnSubmit: PropTypes.bool,
};

SmartSearchForm.defaultProps = {
  initialSearchTerm: '',
  isAlways: false,
  isNextMonth: false,
  isDatepickerVisible: true,
  scrollOnFocus: false,
  defaultDatesOnSubmit: false
};

SmartSearchForm.sanitizeProps = (props) => ({
  ...props,
  isDatepickerVisible: props.isDatepickerVisible == '1',
  scrollOnFocus: props.scrollOnFocus == '1',
  defaultDatesOnSubmit: props.defaultDatesOnSubmit == '1',
  isAlways: props.isAlways == '1',
});

export default SmartSearchForm;
